<template>
    <header class="header-wrapper">
        <div class="container">
            <div class="header-sec">
                <div class="header-nav">
                    <div class="back-arrow">
                        <a @click="$router.back()">
                            <img src="@/assets/images/back-arrow.svg" alt="back-arrow" loading="lazy" />
                        </a>
                    </div>
                    <div class="header-logo">
                        <div class="list-con">
                        <h4 class="text-light">{{ $route?.meta?.title }}</h4>
                        </div>
                    </div>
                </div>
                <div class="header-but">
                    <router-link :to="{name: 'WalletDeposit'}" v-if="$route.name.includes('Withdraw')" class="thm-but">{{ $t('deposit','Deposit') }}</router-link>
                    <router-link :to="{name: 'WalletWithdraw'}" v-if="$route.name.includes('Deposit')" class="thm-but">{{ $t('withdraw','Withdraw') }}</router-link>
                    <router-link :to="{name: 'Wallet'}" class="thm-but balance-btn">
                        <span>B : {{ $auth.user?.balance }}</span>
                        <span class="exp-blance">E : {{ $auth?.user?.expl ? (-1) * $auth?.user?.expl : 0 }}</span>
                    </router-link>
                    <router-link :to="{name: 'notifications'}" class="notification-icon"><img src="@/assets/images/notify.svg" alt="notify"></router-link>
                </div>
            </div>
        </div>
        
    </header>
    <marquee class="announcement-msg" v-if="walletConfig?.announcement?.value">
        {{walletConfig?.announcement?.value}}
    </marquee>
    <RulesModal />
    <EditStakeModal/>
</template>

<script>
import { marquee } from '@template/utils';
import { defineAsyncComponent } from 'vue';
export default {
    name: 'WalletHeader',
    inject: ['walletConfig'],
    components: {
        marquee,
        RulesModal: defineAsyncComponent(() =>
            import('@/shared/components/rules/RulesModal.vue')
        ),
        EditStakeModal: defineAsyncComponent(() =>
            import('@/modules/account/components/EditStakeModal.vue')
        ),
    },
}
</script>
<style scoped>
.header-wrapper .header-logo .list-con .text-light {
	color: var(---color) !important;
}
</style>